import styled from 'styled-components';
import { SuiContainer } from '@splashthat/sui';
import { WORKSPACE_TOPBAR_HEIGHT, containerPaddingM, containerPaddingL } from 'common/styles/variables';

export const SPACING = '0.625rem';

export const SidebarContainer = styled.div`
    display: flex;
    flex-wrap: nowrap;
    height: calc(100vh - ${WORKSPACE_TOPBAR_HEIGHT});
    width: 100%;
    overflow-x: hidden;
`;

export const SidebarPanel = styled(SuiContainer).attrs({
    variation: 'flex-no-shrink full-width',
})`
    padding: ${containerPaddingL} ${containerPaddingM};
    overflow: auto;
    background-color: ${({ theme }) => theme.palette.grayscale.white};
`;
